<template>
    <div class="col-lg-4 col-sm-6 mb-3">
        <a :href="meetingGroup.url">
            <div class="card card-basic card--blue">
                <div class="card__text">
                    <div class="card__text__top">
                        <span class="card__subject">{{ nameWithAcronym }}</span>
                        <h2>
                            {{ meetingGroup.shortName }}
                        </h2>
                        <p
                            v-if="meetingGroup.info"
                            class="card__text__top__info text-fade text-fade--white"
                        >
                            {{ meetingGroup.info }}
                        </p>
                        <p
                            v-if="meetingGroup.infoEn"
                            class="card__text__top__info text-fade text-fade--white"
                        >
                            {{ meetingGroup.infoEn }}
                        </p>
                    </div>
                </div>
                <div v-if="meetingGroup.url" class="card__bottom">
                    <div class="card__bottom__button">
                        <span class="card__bottom__button__content"
                            >Lees meer<span
                                class="icon-angle-right card__bottom__button__content__icon"
                            ></span
                        ></span>
                    </div>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        meetingGroup: {
            type: Object,
            default() {
                return [];
            }
        }
    },

    computed: {
        nameWithAcronym() {
            return ` ${this.meetingGroup.name} (${this.meetingGroup.shortName})`;
        }
    }
};
</script>
